<div class="container col-xxl-8 px-4 py-5 landing-content" >
    <div class="row align-items-center g-5 py-5">
  
        <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Refund Policy</h1>
        <div class="row align-items-center g-5">


            <h2 class="display-5 lh-1 mb-3">1. Introduction</h2>
            <p>This Refund Policy applies to our paid services.</p> 

            <h2 class="display-5 lh-1 mb-3">2. Refund Conditions</h2>
            <p>All fees are non-refundable unless explicitly stated otherwise. We will consider refund requests on a case-by-case basis.</p>
            
            <h2 class="display-5 lh-1 mb-3">3. Refund Procedure</h2>
            <p>To request a refund, contact our support team and provide the relevant payment details and reason for the refund. </p>



      </div>

    </div>
  </div>
